import type {
  ListLocationMembersQuery,
  LocationMembers,
} from './use-location-members';

/**
 * Organizes data from location members and authorizations queries.
 * Separates current user from other members. Sorts location members by role and then email for display.
 */
export const buildLocationMembers = (
  listLocationMembersQuery: ListLocationMembersQuery,
  appUserID: string | undefined
): LocationMembers | undefined => {
  if (!appUserID) {
    return undefined;
  }
  const members = listLocationMembersQuery.data?.members;
  if (!members) {
    return undefined;
  }
  const currentMember = members.find((member) => member.userId === appUserID);
  if (!currentMember) {
    // Should never get here since API fails if the user isn't authenticated.
    return undefined;
  }

  const otherMembers = members.filter((member) => member.userId !== appUserID);
  return {
    current: currentMember,
    others: otherMembers,
  };
};
